// extracted by mini-css-extract-plugin
export default {"card":"ArticleItemMobile_card__skhtp","cardImage":"ArticleItemMobile_cardImage__4vGzO","cardDetails":"ArticleItemMobile_cardDetails__xUtbv"};